import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useTranslation } from 'react-i18next';

interface UserPreferences {
  language?: string;
  timezone?: string;
  date_format?: string;
  time_format?: string;
}

export const useUserPreferences = () => {
  const { i18n } = useTranslation();
  const [preferences, setPreferences] = useState<UserPreferences>({
    language: 'en',
    timezone: 'UTC',
    date_format: 'DD/MM/YYYY',
    time_format: '24h',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPreferences = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          const { data } = await supabase
            .from('user_preferences')
            .select('*')
            .eq('user_id', user.id)
            .single();

          if (data) {
            const prefs = {
              language: data.language || 'en',
              timezone: data.timezone || 'UTC',
              date_format: data.date_format || 'DD/MM/YYYY',
              time_format: data.time_format || '24h',
            };
            setPreferences(prefs);
            
            // Sync i18n language
            if (data.language && i18n.language !== data.language) {
              i18n.changeLanguage(data.language);
            }
          }
        }
      } catch (error) {
        console.error('Error loading preferences:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPreferences();
  }, [i18n]);

  return { preferences, loading };
};
